import inputHandler from './modules/inputHandler'
import platformHandler from './modules/platformHandler'
import pageHandler from './modules/pageHandler'
import trackingHandler from './modules/trackingHandler'

export default {
  inputHandler,
  platformHandler,
  pageHandler,
  trackingHandler
}


// WEBPACK FOOTER //
// ./src/helpers/index.js